<template>
    <div class="my_coupon">
        <van-sticky>
            <div class="table"> <!--{{isFixedTop?'fixed':''}}-->
                <div :class="list_type=='ALL'?'tab-li curr':'tab-li'" @click="bindType('ALL')">全部</div>
                <div :class="list_type=='NOT_USE'?'tab-li curr':'tab-li'" @click="bindType('NOT_USE')">未使用</div>
                <div :class="list_type=='IS_USE'?'tab-li curr':'tab-li'" @click="bindType('IS_USE')">已使用</div>
                <div :class="list_type=='OVER_TIME'?'tab-li curr':'tab-li'" @click="bindType('OVER_TIME')">已过期</div>
            </div>
        </van-sticky>
        <div class="content">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :immediate-check="false"
                    @load="getUserCoupon"
                    class="content-collect"
            >
            <div class="coupon-li" v-for="(item,index) in list" :key="index">
                <div class="train-title" style="padding: 12px 12px 0 12px">
                    <img :src="util.G_CONFIG.logo" v-if="util.G_CONFIG.logo != ''" style="width: 18px;vertical-align: middle;margin-right: 5px">
                    <span v-if="util.G_CONFIG.train_name != ''" style="font-size: 12px;color: #999">{{util.G_CONFIG.train_name}}</span>
                </div>
                <div class="coupon-content">
                    <div class="coupon-type">
                        <span v-if="item.coupon.coupon_type == 1">抵扣券</span>
                        <span v-if="item.coupon.coupon_type == 2">折扣券</span>
                    </div>
                    <div class="coupon-money">
                        <span>{{item.coupon.coupon_name}}</span>

                        <div style="color: #327CE9;float: right">
                            <span v-if="item.coupon.coupon_type == 1"><span class="coupon-money-txt">{{item.coupon.money * 1 }}</span>元</span>
                            <span v-if="item.coupon.coupon_type == 2"><span class="coupon-money-txt">{{item.coupon.discount * 1 }}</span>折</span>
                        </div>
                    </div>
                    <div class="coupon-txt">
                    <span v-if="item.coupon.coupon_type == 1 && item.coupon.full_money*1>0">
                        满{{item.coupon.full_money * 1 }}元减{{item.coupon.money * 1}}元
                    </span>
                        <span v-if="item.coupon.coupon_type == 2 && item.coupon.full_money*1>0">
                        满{{item.coupon.full_money * 1 }}元打{{item.coupon.discount * 1}}折
                    </span>
                        <span v-if="item.coupon.full_money*1 == 0">无门槛使用</span>
                    </div>
                </div>
                <div class="coupon-btn">
                    <div class="coupon-time">
                    <span>
                        此券有效期至{{item.use_time_end_date}}
                    </span>
                    </div>
                    <div class="coupon-receive-btn">
                        <div class="coupon-receive color-327CE9" @click="bindGoCouponCourse(item.coupon_id)"  v-if="item.use_status !='IS_USE' && item.use_status != 'OVER_TIME'">
                            <span>立即使用</span>
                        </div>
                    </div>
                </div>

                <div class="coupon-received">
                    <span v-if="item.use_status =='IS_USE' && is_show">已使用</span>
                    <span v-if="item.use_status =='OVER_TIME' && is_show">已过期</span>
                </div>
            </div>
            </van-list>
        </div>
    </div>
</template>

<script>
    import { List,Sticky } from 'vant';
    export default {
        name: "my_coupon",
        components:{
            [List.name]:List,
            [Sticky.name]:Sticky
        },
        data(){
            return {
                list_type:'ALL',
                list:[],
                total:0,
                page:1,
                pageSize:10,
                loading: false,
                finished: false,
                is_show:false,
            }
        },
        mounted() {
            this.util.hideOptionMenu();
            this.getUserCoupon(1);
        },
        methods:{
            bindType(type){
                this.list_type = type;
                this.is_show = false;
                this.getUserCoupon(1);
            },
            bindGoCouponCourse(coupon_id){
                this.$router.push(this.util.urlPrefix+'/coupon/coupon_course?coupon_id='+coupon_id+'&token='+this.util.token)
            },
            getUserCoupon(page){
                var _self=this;
                if(!page){
                    var pageNo = this.page;
                    pageNo +=1;

                    this.page=pageNo;

                }else{

                    this.page=page;

                }

                this.util.server.mini_coupon.user_coupon({
                    data:{
                        list_type:this.list_type,
                        page:this.page,
                        pagesize:this.pageSize
                    },
                    methods:'get',
                    callback: (res => {
                        const { code, data, msg } = res;
                        if(code == 1) {

                            //赋值总数量
                            if(data.total){
                                this.total=data.total
                            }

                            //1.如果有数据
                            if(data.items && data.items.length>0) {

                                if(page == 1){
                                    this.list=data.items;
                                }else{
                                    //如果翻页 则在数组追加数据
                                    this.list = this.list.concat(data.items);
                                }

                                //判断是否存在下一页
                                this.loading = false;
                                this.is_show=true;
                                //判断是否存在下一页
                                if(this.total*1 == this.list.length){
                                    this.finished=true;
                                }

                            }else{
                                //2.无数据
                                //如果当前页为第一页 则设置页面数据为空数组
                                if (page == 1){
                                    this.list=[];
                                    this.finished=true;
                                    this.is_show=true;
                                    this.loading = false;
                                }
                            }
                        }else{
                            this.util.showToast({
                                message: msg
                            });
                        }
                    })
                });
            },
        }
    }
</script>

<style scoped>
    .table{
        display: table;
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid #eee;
    }
    .table.fixed{
        position: fixed;
        top:0;
        z-index:1;
        margin-top: 0;
    }
    .table .tab-li{
        background-color: #fff;
        display: table-cell;
        font-size: 16px;
        min-width: 74px;
        padding: 0 5px;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        position: relative;
    }
    .table .tab-li.curr:after {
        position: absolute;
        content: "";
        bottom: 0;
        width: 42px;
        height: 3px;
        background: rgba(52, 155, 248, 1);
        opacity: 1;
        border-radius: 4px;
        left: 50%;
        margin-left: -21px;
    }
    .color-FF5C4A{
        color: #FF5C4A;
    }
    .color-327CE9{
        color: #327CE9;
    }
    div{
        color: #3a3a3a;
    }
    .coupon-received{
        position: absolute;
        left: 50%;
        top: 50%;
        color: #FF5C4A;
        font-size: 25px;
        transform: rotate(-28deg);
        opacity: .5;
        margin-left: -30px;
        margin-top: -17px;
    }
    .coupon-surplus{
        font-size: 12px;
        font-weight: 500;
        padding: 2px 5px;
        background-color: #ff847c;
        color: #fff;
        border-radius: 10px;
        margin-left: 5px;
    }
    .coupon-li{
        margin: 10px;
        position: relative;
        background-color: #fff;
        border-radius: 5px;
        overflow: hidden;
    }
    .coupon-content{
        padding: 10px 20px;
    }
    .coupon-type{
        position: absolute;
        right: 0;
        top: 0;
        font-size: 10px;
        padding: 2px 5px;
        background-color: #FF5C4A;
        color: #fff;
        border-radius:4px 4px 4px 0;
    }
    .coupon-money{
        font-weight: bold;
        font-size: 16px;
    }
    .coupon-money-txt{
        font-size: 30px;
        color: #327CE9;
        margin-right: 2px;
    }
    .coupon-txt{
        font-size: 12px;
        margin-top: 5px;
        color: #999;
    }
    .coupon-btn{
        position: relative;
        padding: 25px 20px;
        padding-right: 80px;
        background-image: linear-gradient(to right, #eee 0%, #eee 50%, transparent 50%);
        background-size: 28px 1px;
        background-repeat: repeat-x;
    }
    .coupon-btn::after,.coupon-btn::before{
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        background-color: #f8f8f8;
        border-radius: 10px;
    }
    .coupon-btn::after{
        top: -10px;
        right: -10px;
    }
    .coupon-btn::before{
        top: -10px;
        left: -10px;
    }
    .coupon-time{
        display: inline-block;
        font-size: 12px;
        color: #999999;
    }
    .coupon-receive{
        font-size: 12px;
    }
    .coupon-receive-btn{
        position: absolute;
        right: 10px;
        top: 0;
        width: 58px;
        height: 100%;
        /*flex 布局*/
        display: flex;
        flex-wrap: wrap;
        /*实现垂直居中*/
        align-items: center;
        /*实现水平居中*/
        justify-content: center;
    }
</style>
